import { isElectronHashBuild } from './printElectron';

/**
 * Print helper.
 * - Website: hidden iframe → window.print() (browser handles the dialog).
 * - Electron: full-screen in-app preview overlay with Print / Cancel buttons.
 */
export const openPrintPreview = (htmlContent, _title = 'Print') => {
  if (isElectronHashBuild()) {
    showElectronPreview(htmlContent);
    return null;
  }

  // ── Website: hidden iframe ──
  const iframe = document.createElement('iframe');
  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:none;visibility:hidden;';
  document.body.appendChild(iframe);

  const pw = iframe.contentWindow;
  if (!pw) { document.body.removeChild(iframe); return null; }

  pw.document.open();
  pw.document.write(htmlContent);
  pw.document.close();

  setTimeout(() => {
    pw.focus();
    pw.print();
    setTimeout(() => { if (document.body.contains(iframe)) document.body.removeChild(iframe); }, 1000);
  }, 300);

  return pw;
};

// ── Electron: in-app preview overlay ──
function showElectronPreview(htmlContent) {
  // Backdrop
  const overlay = document.createElement('div');
  overlay.id = 'print-preview-overlay';
  overlay.style.cssText = `
    position: fixed; inset: 0; z-index: 99999;
    background: rgba(0,0,0,0.75);
    display: flex; flex-direction: column;
    font-family: system-ui, -apple-system, sans-serif;
  `;

  // Toolbar
  const toolbar = document.createElement('div');
  toolbar.style.cssText = `
    display: flex; align-items: center; gap: 12px;
    padding: 10px 20px;
    background: #1a1a2e;
    color: #fff; font-size: 14px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.4);
    flex-shrink: 0;
  `;

  const title = document.createElement('span');
  title.textContent = 'Print Preview';
  title.style.cssText = 'font-weight:600; font-size:16px; margin-right:auto;';

  const btnPrint = document.createElement('button');
  btnPrint.textContent = '🖨️  Print';
  btnPrint.style.cssText = `
    padding: 8px 24px; border: none; border-radius: 6px;
    background: #4361ee; color: #fff;
    font-size: 14px; font-weight: 600; cursor: pointer;
  `;

  const btnCancel = document.createElement('button');
  btnCancel.textContent = '✕  Cancel';
  btnCancel.style.cssText = `
    padding: 8px 24px; border: none; border-radius: 6px;
    background: #e74c3c; color: #fff;
    font-size: 14px; font-weight: 600; cursor: pointer;
  `;

  toolbar.appendChild(title);
  toolbar.appendChild(btnPrint);
  toolbar.appendChild(btnCancel);

  // Preview iframe (visible)
  const iframe = document.createElement('iframe');
  iframe.style.cssText = `
    flex: 1; border: none;
    margin: 16px auto;
    width: 90%; max-width: 900px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.5);
  `;

  overlay.appendChild(toolbar);
  overlay.appendChild(iframe);
  document.body.appendChild(overlay);

  // Write content to preview iframe
  const pw = iframe.contentWindow;
  if (pw) {
    pw.document.open();
    pw.document.write(htmlContent);
    pw.document.close();
  }

  // Close overlay
  const close = () => {
    if (document.body.contains(overlay)) {
      document.body.removeChild(overlay);
    }
  };

  // Cancel
  btnCancel.addEventListener('click', close);

  // Print: trigger print on the iframe content, then close overlay
  btnPrint.addEventListener('click', () => {
    if (pw) {
      pw.focus();
      pw.print();
    }
    close();
  });

  // Escape key to cancel
  const onKey = (e) => {
    if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); }
  };
  document.addEventListener('keydown', onKey);
}
